import { render, staticRenderFns } from "./tencentcustomaudiences.vue?vue&type=template&id=008a352b&"
import script from "./tencentcustomaudiences.vue?vue&type=script&lang=js&"
export * from "./tencentcustomaudiences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports